import { queryOptions } from "@tanstack/react-query";
import { createServerFn, createServerOnlyFn } from "@tanstack/react-start";
import { vendureCacheConfig } from "@/api/vendure/cache.config";
import { vendure } from "@/lib/vendure";
import type { Venue } from "./merchant.types";

const fetchMerchant = createServerFn({ method: "GET" })
  .inputValidator((d: { slug: string }) => d)
  .handler(async ({ data }): Promise<Venue[]> => {
    const { data: venue } = await vendure.get<Venue>(
      `/api/v1/venue/${data.slug}`,
    );
    return [venue];
  });

// Server-only twin of fetchMerchant for server routes: a server fn with no client caller
// isn't registered in production builds.
export const fetchVenue = createServerOnlyFn(async (slug: string) => {
  const { data } = await vendure.get<Venue>(
    `/api/v1/venue/${encodeURIComponent(slug)}`,
  );
  return data;
});

export const merchantQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: ["merchant", slug],
    queryFn: () => fetchMerchant({ data: { slug } }),
    enabled: slug.trim().length > 0,
    ...vendureCacheConfig,
  });
